import { Unsubscribe } from '@mui/icons-material';

export const EMAIL_REGEX =
	/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const WEBSITE_REGEX = /^(https?:\/\/)?([\da-z\.-]+)\.([a-z\.]{2,6})([\/\w \.-]*)*\/?$/;

export const PHONE_REGEX = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im;

export const LATIN_OR_NUMBERS_REGEX = /^[A-Za-z0-9\s]*$/;

export type obj = { [key: string]: string | number };

export const OrderBy = {
	ACSENDING: 'asc',
	DESENDING: 'desc',
};

export const maxFileSize = 2000000;

export const acceptableFileFormats =
	'.pdf,.jpeg,.jpg,.png,.gif,.doc,.docx,.vnd.openxmlformats-officedocument.wordprocessingml.document,.msword';

//dev - https://red-dune-06d59d103.2.azurestaticapps.net/
//staging - https://demo-open.asfs.co.il/
//local - 127.0.0.1

export const globalEndpoints = (function () {
	let host = document.location.host;
	let endpointsObj: { [key: string]: string } = {
		REACT_APP_MSAL_POST_LOGOUT_REDIRECT: 'https://login.microsoftonline.com/common/oauth2/logout',
		REACT_APP_ADB2C_SIGN_IN_FLOW: 'B2C_1_sign_in',
	};
	if (host.includes('localhost')) {
		endpointsObj = {
			...endpointsObj,
			NODE_ENV: 'development',
			REACT_APP_ENV: 'development',
			REACT_APP_SERVER_URL: 'http://localhost:8000/api/v1',
			REACT_APP_MSAL_REDIRECT: 'http://localhost:3000/',
			REACT_APP_ADB2C_CLIENT_ID: '398d2cc3-94c1-40e9-a6d5-9d0984bb3abc',
			REACT_APP_ADB2C_AUTHORITY: 'https://altfsdev.b2clogin.com/altfsdev.onmicrosoft.com/B2C_1_sign_in',
			REACT_APP_ADB2C_AUTHORITY_DOMAIN: 'altfsdev.b2clogin.com',
			REACT_APP_RECAPTCHA_CLIENT_SECRET: '6Lff7NQrAAAAAFMLjeJRn9Hahv1GbGWOY_TkCq1_',
		};
	} else if (host.includes('brave-hill')) {
		endpointsObj = {
			...endpointsObj,
			NODE_ENV: 'development',
			REACT_APP_ENV: 'development',
			REACT_APP_SERVER_URL: 'https://open-dev-weu-proxy-server.azurewebsites.net/api/v1',
			REACT_APP_MSAL_REDIRECT: 'https://brave-hill-008446803.1.azurestaticapps.net',
			REACT_APP_ADB2C_CLIENT_ID: '398d2cc3-94c1-40e9-a6d5-9d0984bb3abc',
			REACT_APP_ADB2C_AUTHORITY: 'https://altfsdev.b2clogin.com/altfsdev.onmicrosoft.com/B2C_1_sign_in',
			REACT_APP_ADB2C_AUTHORITY_DOMAIN: 'altfsdev.b2clogin.com',
			REACT_APP_RECAPTCHA_CLIENT_SECRET: '6Lff7NQrAAAAAFMLjeJRn9Hahv1GbGWOY_TkCq1_',
		};
	} else if (host.includes('demo.open')) {
		endpointsObj = {
			...endpointsObj,
			NODE_ENV: 'development',
			REACT_APP_ENV: 'production',
			REACT_APP_SERVER_URL: 'https://demo-open.asfs.co.il/api/v1',
			REACT_APP_MSAL_REDIRECT: 'https://demo-open.asfs.co.il',
			REACT_APP_ADB2C_CLIENT_ID: 'e15c80a0-4cd9-4f2a-98a5-41c5bcba6430',
			REACT_APP_ADB2C_AUTHORITY: 'https://altfstest.b2clogin.com/altfstest.onmicrosoft.com/B2C_1_sign_in',
			REACT_APP_ADB2C_AUTHORITY_DOMAIN: 'altfstest.b2clogin.com',
			REACT_APP_RECAPTCHA_CLIENT_SECRET: '6Lff7NQrAAAAAFMLjeJRn9Hahv1GbGWOY_TkCq1_',
		};
	} else if (host.includes('open-global') || host.includes('open.global')) {
		endpointsObj = {
			...endpointsObj,
			NODE_ENV: 'development',
			REACT_APP_ENV: 'production',
			REACT_APP_SERVER_URL: 'https://www.open-global.com/api/v1',
			REACT_APP_MSAL_REDIRECT: 'https://www.open-global.com',
			REACT_APP_ADB2C_CLIENT_ID: '7969596a-23e8-470b-b207-6432a1b57fbc',
			REACT_APP_ADB2C_AUTHORITY: 'https://altfsprod.b2clogin.com/altfsprod.onmicrosoft.com/B2C_1_sign_in',
			REACT_APP_ADB2C_AUTHORITY_DOMAIN: 'altfsprod.b2clogin.com',
			REACT_APP_RECAPTCHA_CLIENT_SECRET: '6Lff7NQrAAAAAFMLjeJRn9Hahv1GbGWOY_TkCq1_',
		};
	} else
		endpointsObj = {
			...endpointsObj,
			NODE_ENV: 'development',
			REACT_APP_ENV: 'development',
			REACT_APP_SERVER_URL: '',
			REACT_APP_MSAL_REDIRECT: '',
			REACT_APP_ADB2C_CLIENT_ID: '',
		};

	return endpointsObj;
})();

export const CCUniqueNames = {
	//routing_code: 'aba',
	// beneficiaries/get-required-details uses `acct_number`; beneficiaries/validate errors use `account_number`.
	account_number: 'page.beneficiary.create.step.2.payment_method.acct_number.text',
	unsupported_beneficiary_country_code: 'page.beneficiary.create.step.1.beneficiary_details.country.text',
};

export const CCUniqueNamesMessage = {
	//routing_code: 'aba',
	//account_number:'acct_number',
	unsupported_beneficiary_country_code: 'servers.errors.codes.1101',
};

export const trimAllStringsInObject = (data: string | any) => {
	Object.keys(data).map((key) => {
		if (typeof data[key] === 'string') {
			data[key] = data[key].trim();
		} else {
			trimAllStringsInObject(data[key]);
		}
	});
};

export const trimAllStringsInFormdata = (data: string | any) => {
	const newFormData = new FormData();
	for (const pair of data.entries()) {
		newFormData.append(pair[0], typeof pair[1] === 'string' ? pair[1].trim() : pair[1]);
	}
	return newFormData;
};

export const DUMMY_CITY_NAMES = [
	'-',
	'x',
	'n/a',
	'test',
	'na',
	'xx',
	'xxx',
	'tbd',
	'unknown',
	'none',
	'city',
	'address',
	'0',
	'.',
	'--',
	'null',
	'no',
];

export const isValidCityName = (city: string) => {
	const normalizedCity = city.trim().toLowerCase();
	return normalizedCity.length > 2 && !DUMMY_CITY_NAMES.includes(normalizedCity);
};
